import { mapState } from 'vuex'

export default {
  name: 'header-main',
  computed: {
    ...mapState('global', ['isSitecore']),
    ...mapState('global', ['sidebarOpened']),
    scope () {
      return {
        sidebarOpened: this.sidebarOpened,
        bookingWidgetIsMounted: this.bookingWidgetIsMounted,
        navButtonToggleIsMounted: this.navButtonToggleIsMounted
      }
    }
  },
  data: () => ({
    bookingWidgetIsMounted: false,
    navButtonToggleIsMounted: false
  }),
  created() {
    this.handleEvents()
  },
  mounted() {
    if (this.isSitecore) {
      this.$el.closest('header').classList.add('is-sitecore')
    }

  },
  watch: {
    sidebarOpened (open) {
      if (open) {
        this.$el.closest('header').classList.add('sidebar-mode')
      } else {
        this.$el.closest('header').classList.remove('sidebar-mode')
      }
    },
  },
  render() {
    return this.$scopedSlots.default(this.scope)
  },
  methods: {
    bookingWidgetMounted() {
      this.bookingWidgetIsMounted = true
    },
    navButtonToggleMounted() {
      this.navButtonToggleIsMounted = true
    },
    handleEvents() {
      this.$root.$on('nav-button-toggle-mounted', this.navButtonToggleMounted)
      this.$root.$on('booking-widget-mounted', this.bookingWidgetMounted)
    }
  }
}
